import {getColorStyle} from '@/utilities/color-style-map';
import classNames from 'classnames';
import {ComponentChildren} from 'preact';

export default PlanOptionButton;

function PlanOptionButton({
  children,
  color = 'primary-blue',
  dataTestId = '',
  isSelected = false,
  onClick,
}: PlanOptionButtonProps) {
  const colorStyle = getColorStyle(color);

  return (
    <button
      data-testid={dataTestId}
      className={classNames(
        'fast-transition flex h-14 w-full items-center justify-center rounded-md border-2',
        {
          [`${colorStyle.border} ${colorStyle.background} text-bright-white`]:
            isSelected,
          'border-neutral-gray bg-bright-white': !isSelected,
        }
      )}
      onClick={onClick}
    >
      <h3 className="md:text-3xl">{children}</h3>
    </button>
  );
}

export type PlanOptionButtonProps = {
  children?: ComponentChildren;
  color?: string;
  dataTestId?: string;
  isSelected?: boolean;
  onClick?: () => void;
};
